// extracted by mini-css-extract-plugin
export var dropdownContainer = "_oa-0";
export var leftAlign = "_oa-4";
export var listItem = "_oa-2";
export var listItemWrapper = "_oa-1";
export var operationText = "_oa-3";